export default __webpack_public_path__ + "static/media/iphone.8a5ea080.png";